import { makeHttpRequest } from "@/shared";

export const deleteInventoryPrice = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/inventory/price/${id}`,
            method: "DELETE",
        })
    ).data;

    return response;
};
